/** @format */

import {ReactNode} from 'react';

import {FilterBar} from './components/FilterBar';
import {FilterOption, FilterValue, TableFilters} from './components/FilterBar/types';
import {StyledTableContainer} from './styles';
import {ColumnType, TableVariant} from './types';

interface Props {
  variant: TableVariant;
  enableFilters: boolean;
  filters: TableFilters;
  filterOptions: Record<string, FilterOption[]>;
  onFilterChange: (columnId: string, value: FilterValue) => void;
  onResetFilters: () => void;
  columns: ColumnType[];
  filterBarRef?: React.RefObject<HTMLDivElement>;
  filterBarActions?: ReactNode;
  stickyHeader?: boolean;
  stickyFooter?: boolean;
  children: ReactNode;
}

export const TableShell = ({
  variant,
  enableFilters,
  filters,
  filterOptions,
  onFilterChange,
  onResetFilters,
  columns,
  filterBarRef,
  filterBarActions,
  stickyHeader,
  stickyFooter,
  children,
}: Props) => {
  return (
    <>
      {enableFilters && (
        <FilterBar
          ref={filterBarRef}
          filters={filters}
          filterOptions={filterOptions}
          onFilterChange={onFilterChange}
          onResetFilters={onResetFilters}
          columns={columns}
          actions={filterBarActions}
        />
      )}

      <StyledTableContainer
        variant={variant}
        stickyHeader={stickyHeader}
        stickyFooter={stickyFooter}
      >
        {children}
      </StyledTableContainer>
    </>
  );
};
